import React, { ReactNode, useState } from 'react';
import { useEffect } from 'react';
import { useLDClient, useFlags } from 'launchdarkly-react-client-sdk';
import { useClientTokenManager, FeatureFlagsContext, PageLoader } from '@cko/dashboard-shared';

type LdCustomContext = {
  clientId?: string;
  subEntityId?: string;
  permissions: string[];
  userRoles: string[];
};

export const FeatureFlagConfigurationManager = ({ children }: { children: ReactNode }) => {
  const ldClient = useLDClient();

  const [isUserIdentified, setIsUserIdentified] = useState(false);
  const { tokenProperties } = useClientTokenManager();
  const {
    userId: key,
    sub: email,
    permissions,
    userRoles,
    clientId,
    subEntityId,
  } = tokenProperties;

  const flags = useFlags();

  useEffect(() => {
    if (key && (clientId || subEntityId)) {
      const custom: LdCustomContext = { permissions, userRoles };
      if (clientId) {
        custom.clientId = clientId;
      } else if (subEntityId) {
        custom.subEntityId = subEntityId;
      }
      const ldUserContext = { custom, email, key };

      ldClient?.identify(ldUserContext).then(() => setIsUserIdentified(true));
    }
  }, [clientId, email, key, subEntityId, permissions, userRoles]);

  const getFeatureFlag = (flag: string) => {
    return flags[flag];
  };

  const getMultiVariateFlag = (flag: string) => {
    return flags[flag];
  };

  return (
    <FeatureFlagsContext.Provider
      value={{ getFeatureFlag, getMultiVariateFlag, isUserIdentified, setIsUserIdentified }}
    >
      {isUserIdentified ? children : <PageLoader />}
    </FeatureFlagsContext.Provider>
  );
};
